// extracted by mini-css-extract-plugin
export var person = "Person-module--person--7QeiQ";
export var avatar = "Person-module--avatar--3KfSS";
export var personName = "Person-module--personName--SdhV4";
export var personTitle = "Person-module--personTitle--1FWI_";